module.exports = __webpack_public_path__ + "img/sld_mfm_aux_withoutStick.82f8f5ea.svg";